import { inject } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { tapResponse } from '@ngrx/operators';
import { UploadFileService } from '../services/upload-file.service';
import { FileAnswer } from '../models/Answer.model';
import { pipe, switchMap, tap } from 'rxjs';
interface UploadFileState {
  loading: boolean;
  error: string | null;
}
export class UploadFileStore extends ComponentStore<UploadFileState> {
  #uploadFileService = inject(UploadFileService);
  constructor() {
    super({
      loading: false,
      error: null,
    });
  }
  readonly loading$ = this.select((state) => state.loading);
  readonly error$ = this.select((state) => state.error);

   readonly uploadFile = this.effect<{
    file: File;
    onSuccess: (uploadedFile: FileAnswer) => void;
  }>(
    pipe(
      tap(() => this.patchState({ loading: true, error: null })),

      switchMap(({ file, onSuccess }) =>
        this.#uploadFileService.uploadFile(file).pipe(
          tapResponse(
            (uploadedFile) => {
              this.patchState({ loading: false });

              onSuccess({
                ...uploadedFile,
                base64: null,
              });
            },
            (error: unknown) => {
              console.error('[FileUploadStore] upload failed', error);

              this.patchState({
                loading: false,
                error: 'Upload failed',
              });
            },
          ),
        ),
      ),
    ),
)
}
